import {
  fetchMyBuyAppsList,
  fetchMyBuyAppsAllInfo
} from '@/api/myBuyApps';

const myBuyApps = {
  state: {
  },

  mutations: {
  },

  actions: {
    // 获取企业已购应用列表
    GetMyBuyAppsList({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchMyBuyAppsList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取企业某个已购应用详情数据
    GetMyBuyAppsAllInfo({ commit }, resdata) {
      return new Promise((resolve, reject) => {
        fetchMyBuyAppsAllInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default myBuyApps;



// WEBPACK FOOTER //
// ./src/store/modules/myBuyApps.js